
import styles from '../on-boarding/onboarding.module.scss';

export const PlatformIllustration = () => (
  <svg
    className={styles.hero_art}
    viewBox="0 0 524 472"
    role="img"
    aria-label="A Realtime Tech platform constellation"
  >
    <defs>
      <radialGradient id="ob_core_halo" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#04adc3" stopOpacity="0.34" />
        <stop offset="55%" stopColor="#55d7ee" stopOpacity="0.12" />
        <stop offset="100%" stopColor="#55d7ee" stopOpacity="0" />
      </radialGradient>
      <linearGradient id="ob_glass" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#ffffff" stopOpacity="0.98" />
        <stop offset="100%" stopColor="#ffffff" stopOpacity="0.82" />
      </linearGradient>
      <linearGradient id="ob_bar" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0%" stopColor="#04adc3" />
        <stop offset="100%" stopColor="#55d7ee" />
      </linearGradient>
      <linearGradient id="ob_spark" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0%" stopColor="#04adc3" stopOpacity="0" />
        <stop offset="100%" stopColor="#04adc3" />
      </linearGradient>
    </defs>

    {/* breathing halo behind the core */}
    <circle className={styles.core_halo} cx="262" cy="236" r="182" fill="url(#ob_core_halo)" />

    {/* orbit rings */}
    <g className={`${styles.orbit_ring} ${styles.orbit_slow}`}>
      <circle
        cx="262"
        cy="236"
        r="196"
        fill="none"
        stroke="rgba(9,45,56,0.13)"
        strokeWidth="1"
        strokeDasharray="2 9"
      />
    </g>
    <g className={`${styles.orbit_ring} ${styles.orbit_mid}`}>
      <circle
        cx="262"
        cy="236"
        r="150"
        fill="none"
        stroke="rgba(4,173,195,0.3)"
        strokeWidth="1.2"
        strokeDasharray="34 14"
      />
    </g>
    <g className={`${styles.orbit_ring} ${styles.orbit_fast}`}>
      <circle
        cx="262"
        cy="236"
        r="106"
        fill="none"
        stroke="rgba(9,45,56,0.1)"
        strokeWidth="1"
      />
      <circle cx="368" cy="236" r="3.5" fill="#04adc3" />
    </g>

    {/* live wires from the core to each product */}
    <g fill="none" stroke="#04adc3" strokeWidth="1.7" strokeLinecap="round" opacity="0.75">
      <path className={styles.wire} d="M296 206 C324 172 330 140 352 108" />
      <path className={styles.wire} d="M300 268 C332 300 350 320 384 342" />
      <path className={styles.wire} d="M222 232 C186 226 152 216 118 212" />
    </g>

    {/* product satellites */}
    <g className={styles.float_a}>
      <rect x="317" y="57" width="70" height="70" rx="22" fill="url(#ob_glass)" stroke="rgba(9,45,56,0.09)" />
      <rect x="317" y="57" width="70" height="70" rx="22" fill="none" stroke="rgba(4,173,195,0.18)" />
      <image href="/assets/images/live-connect-short.svg" x="333" y="73" width="38" height="38" />
    </g>
    <g className={styles.float_b}>
      <rect x="353" y="315" width="70" height="70" rx="22" fill="url(#ob_glass)" stroke="rgba(9,45,56,0.09)" />
      <rect x="353" y="315" width="70" height="70" rx="22" fill="none" stroke="rgba(0,140,255,0.16)" />
      <image href="/assets/images/agent-lab-short.svg" x="371" y="330" width="34" height="40" />
    </g>
    <g className={styles.float_c}>
      <rect x="83" y="177" width="70" height="70" rx="22" fill="url(#ob_glass)" stroke="rgba(9,45,56,0.09)" />
      {/* docs glyph: a page with a folded corner */}
      <g
        transform="translate(2 4)"
        stroke="#04adc3"
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M106 188 h14 l10 10 v30 a4 4 0 0 1 -4 4 h-20 a4 4 0 0 1 -4 -4 v-36 a4 4 0 0 1 4 -4 z" />
        <path d="M120 188 v8 a2 2 0 0 0 2 2 h8" />
        <path d="M110 212 h13" opacity="0.6" />
        <path d="M110 220 h15" opacity="0.6" />
      </g>
    </g>

    {/* core: the ART mark */}
    <g>
      <rect
        x="206"
        y="180"
        width="112"
        height="112"
        rx="34"
        fill="url(#ob_glass)"
        stroke="rgba(4,173,195,0.22)"
        strokeWidth="1.2"
      />
      <rect
        x="214"
        y="188"
        width="96"
        height="96"
        rx="28"
        fill="none"
        stroke="rgba(9,45,56,0.05)"
      />
      <image href="/assets/images/A-Realtime-Tech-short-logo.svg" x="230" y="204" width="64" height="64" />
    </g>

    {/* floating telemetry: latency */}
    <g className={styles.float_c}>
      <rect x="26" y="66" width="168" height="66" rx="20" fill="url(#ob_glass)" stroke="rgba(9,45,56,0.08)" />
      <text x="46" y="93" fill="#9aabb2" fontSize="9" fontWeight="600" letterSpacing="1.6" fontFamily="Lexend, sans-serif">
        ROUND TRIP
      </text>
      <text x="46" y="116" fill="#0b2028" fontSize="19" fontWeight="600" letterSpacing="-0.6" fontFamily="Lexend, sans-serif">
        42 ms
      </text>
      <path
        d="M126 112 l10 -12 l10 8 l10 -18 l10 10"
        fill="none"
        stroke="url(#ob_spark)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>

    {/* floating telemetry: message stream */}
    <g className={styles.float_a}>
      <rect x="24" y="326" width="196" height="116" rx="22" fill="url(#ob_glass)" stroke="rgba(9,45,56,0.08)" />
      <circle cx="46" cy="352" r="4" fill="#04adc3" />
      <text x="58" y="356" fill="#9aabb2" fontSize="9" fontWeight="600" letterSpacing="1.6" fontFamily="Lexend, sans-serif">
        MESSAGES STREAMING
      </text>
      <rect className={styles.bar_fill} x="44" y="374" width="140" height="7" rx="3.5" fill="url(#ob_bar)" />
      <rect className={`${styles.bar_fill} ${styles.bar_fill_b}`} x="44" y="392" width="112" height="7" rx="3.5" fill="url(#ob_bar)" opacity="0.7" />
      <rect className={`${styles.bar_fill} ${styles.bar_fill_c}`} x="44" y="410" width="152" height="7" rx="3.5" fill="url(#ob_bar)" opacity="0.45" />
    </g>

    {/* sparkles */}
    <circle className={styles.spark} cx="454" cy="196" r="3.5" fill="#04adc3" />
    <circle className={`${styles.spark} ${styles.spark_b}`} cx="230" cy="52" r="2.5" fill="#55d7ee" />
    <circle className={`${styles.spark} ${styles.spark_c}`} cx="272" cy="424" r="3" fill="#04adc3" />
  </svg>
);

export const WorkspaceGlyph = () => (
    <svg className={styles.setup_glyph} viewBox="0 0 120 120" role="img" aria-label="Project workspace">
        <defs>
            <radialGradient id="ob_glyph_halo" cx="50%" cy="50%" r="50%">
                <stop offset="0%" stopColor="#04adc3" stopOpacity="0.26" />
                <stop offset="100%" stopColor="#04adc3" stopOpacity="0" />
            </radialGradient>
            <linearGradient id="ob_plate_a" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#04adc3" />
                <stop offset="100%" stopColor="#55d7ee" />
            </linearGradient>
            <linearGradient id="ob_plate_b" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#0b8ea3" />
                <stop offset="100%" stopColor="#04adc3" />
            </linearGradient>
        </defs>

        <circle cx="60" cy="60" r="58" fill="url(#ob_glyph_halo)" />

        <g className={styles.glyph_orbit}>
            <circle cx="60" cy="60" r="50" fill="none" stroke="rgba(4,173,195,0.24)" strokeWidth="1" strokeDasharray="26 12" />
            <circle cx="110" cy="60" r="3" fill="#04adc3" />
        </g>

        {/* bottom plate */}
        <g className={`${styles.glyph_plate} ${styles.glyph_plate_c}`} opacity="0.35">
            <path d="M60 82 L88 96 L60 110 L32 96 Z" fill="url(#ob_plate_b)" />
        </g>
        {/* middle plate */}
        <g className={`${styles.glyph_plate} ${styles.glyph_plate_b}`} opacity="0.65">
            <path d="M60 62 L88 76 L60 90 L32 76 Z" fill="url(#ob_plate_b)" />
        </g>
        {/* top plate */}
        <g className={styles.glyph_plate}>
            <path d="M60 42 L88 56 L60 70 L32 56 Z" fill="url(#ob_plate_a)" />
            <path d="M60 42 L88 56 L60 70 L32 56 Z" fill="none" stroke="#ffffff" strokeOpacity="0.7" strokeWidth="1.2" />
        </g>
    </svg>
);

export const SuccessMark = () => (
  <svg className={styles.success_mark} viewBox="0 0 100 100" role="img" aria-label="Setup complete">
    <defs>
      <linearGradient id="ob_ring" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#04adc3" />
        <stop offset="100%" stopColor="#55d7ee" />
      </linearGradient>
    </defs>

    <circle className={styles.halo_ring} cx="50" cy="50" r="40" fill="none" stroke="rgba(4,173,195,0.4)" strokeWidth="1.5" />
    <circle className={`${styles.halo_ring} ${styles.halo_ring_b}`} cx="50" cy="50" r="40" fill="none" stroke="rgba(4,173,195,0.4)" strokeWidth="1.5" />

    <circle cx="50" cy="50" r="38" fill="rgba(4,173,195,0.07)" />
    <circle
      className={styles.draw_ring}
      cx="50"
      cy="50"
      r="34"
      fill="none"
      stroke="url(#ob_ring)"
      strokeWidth="3"
      strokeLinecap="round"
      transform="rotate(-90 50 50)"
    />
    <path
      className={styles.draw_check}
      d="M36 51 L46 61 L65 41"
      fill="none"
      stroke="#04adc3"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
